<template>
  <a-range-picker class="may-date" :value="value" :format="props.format" :valueFormat="props.valueFormat" :disabledDate="props.disabledDate" @change="change" @openChange="props.onOpenChange" @calendarChange="props.onCalendarChange"/>
</template>
<script setup>
  import { ref, defineProps, defineEmits, watch } from 'vue';
  import dayjs from 'dayjs';
  const props = defineProps({
    modelValue: {},
    begin: {
      type: [String],
      default: ''
    },
    end: {
      type: [String],
      default: ''
    },
    value1: {
      type: [String],
      default: ''
    },
    value2: {
      type: [String],
      default: ''
    },
    valueFormat:{
      type: [String],
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    format:{
      type: [String],
      default: 'YYYY-MM-DD'
    },
    disabledDate: {
      type: Function,
      default: undefined
    },
    onOpenChange: {
      type: Function,
      default: undefined
    },
    onCalendarChange: {
      type: Function,
      default: undefined
    },
  });

  const emits = defineEmits(['update:modelValue', 'update:begin', 'update:end', 'update:value1', 'update:value2', 'change']);
  
  const value = ref([]);
  watch(() => props.modelValue, v => {
    if (v && v.length == 2 && !(v[0] instanceof dayjs)) {
      value.value = [dayjs(v[0], props.format), dayjs(v[1], props.format)];
    }
  }, { immediate: true });

  const setFun = (v, name, i) => {
    if (v === '' || v === null) {
      value.value[i] = undefined;
      return; // 直接返回，避免后续处理
    }
    if (v && v.length != props.valueFormat.length) {
      emits(`update:${name}`, dayjs(v).format(props.valueFormat));
    }
    if (v && !(v instanceof dayjs)) {
      const parsedDate = dayjs(props[name], props.format);
      // 验证日期是否有效
      if (parsedDate.isValid()) {
        value.value[i] = parsedDate;
      } else {
        value.value[i] = undefined;
      }
    }
  }

  watch(() => props.begin, v => { setFun(v, 'begin', 0); }, { immediate: true });
  watch(() => props.end, v => { setFun(v, 'end', 1); }, { immediate: true });
  watch(() => props.value1, v => { setFun(v, 'value1', 0); }, { immediate: true });
  watch(() => props.value2, v => { setFun(v, 'value2', 1); }, { immediate: true });

  const change = (date, dateStr) => {
    let newDateStr = [];
    if (!dateStr[0] && !dateStr[1]) {
      newDateStr = [];
    } else if (props.valueFormat == 'YYYY-MM-DD HH:mm:ss') {
      const start = dateStr[0]? dayjs(dateStr[0]).format('YYYY-MM-DD') + ' 00:00:00' : null;
      const end = dateStr[1]? dayjs(dateStr[1]).format('YYYY-MM-DD') + ' 23:59:59' : null;
      newDateStr = [start, end];
    } else {
      const start = dateStr[0]? dayjs(dateStr[0]).format(props.valueFormat) : null;
      const end = dateStr[1]? dayjs(dateStr[1]).format(props.valueFormat) : null;
      newDateStr = [start, end];
    }
    emits('change', date, newDateStr);
    emits('update:modelValue', newDateStr);
    emits('update:begin', newDateStr[0]);
    emits('update:end', newDateStr[1]);
    emits('update:value1', newDateStr[0]);
    emits('update:value2', newDateStr[1]);
  }

</script>
<style scoped>
  .may-date {
    width: 100%;
  }

</style>